<template>
<v-main>

    <v-container fluid>

        <v-slide-y-transition mode="out-in">

            <v-layout column align-left>

                <h1>Cadastro de {{gridConfig.title}}</h1>                    
                <MdTable :devexpress="true" :config="gridConfig" :parentRefs="$refs">

                    <template slot="modal">

                        <fields  ref="refsManutencao" :gridConfig="gridConfig" :exclusao=false :usuarios="listaUsuarios" :empresas="listaEmpresas" />

                    </template>

                    <template slot="modal-excluir">

                        <fields ref="refsExclusao" :gridConfig="gridConfig" :exclusao=true :usuarios="listaUsuarios" :empresas="listaEmpresas"/>

                    </template>

                </MdTable>

            </v-layout>

        </v-slide-y-transition>

    </v-container>

</v-main>
</template>

<script>
    /* eslint-disable */
    import Model from "./EmpresasUsuariosModel.js";

    import fields from "./EmpresasUsuariosFields"

    import MdTable from "@/lib/components/table/MdTable";

    export default {
    name: "EmpresasUsuarios",

    components: {
        MdTable,
        fields
    },

    data() {
        return {
            gridConfig: new Model(this.$store),
            listaUsuarios:[],
            listaEmpresas:[],
            modalPermite: true,
            modalNPermite: false,
        };
    },
  computed:{
    getRefs(){
        return this.$refs;
      },
  },
  methods:{
      async getUsuarios(){
          await this.gridConfig.getUsuarios()
          .then( (response)=>{
              this.listaUsuarios = response.data;
          })
          .catch( (error)=>{
              console.log("erro ao trazer usuários",error);
          })

      },
      async getEmpresas(){
          await this.gridConfig.getEmpresas()
          .then( (response)=>{
              this.listaEmpresas = response.data;
          })
          .catch( (error)=>{
              console.log("erro ao trazer empresas",error);
          })
      }
  },
  async mounted() {
      await this.getUsuarios();
      await this.getEmpresas();
  }
};
</script>

<style>
</style>
